"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var TextInput_1 = __importDefault(require("stremio/components/TextInput"));
var Overview_1 = __importDefault(require("./Overview"));
var Choices_1 = __importDefault(require("./Choices"));
var Selection_less_1 = __importDefault(require("./Selection.less"));
var SEARCHABLE_OPTIONS_COUNT = 8;
var Selection = function (_a) {
    var _b, _c;
    var inputs = _a.inputs, onCloseRequest = _a.onCloseRequest;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = (0, react_1.useState)(null), activeFilterId = _d[0], setActiveFilterId = _d[1];
    var _e = (0, react_1.useState)(''), search = _e[0], setSearch = _e[1];
    var headingRef = (0, react_1.useRef)(null);
    var activeFilter = (_b = inputs.find(function (_a) {
        var id = _a.id;
        return id === activeFilterId;
    })) !== null && _b !== void 0 ? _b : null;
    var openFilter = (0, react_1.useCallback)(function (id) {
        var _a;
        (_a = headingRef.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
        setSearch('');
        setActiveFilterId(id);
    }, []);
    var onBackClick = (0, react_1.useCallback)(function () { return openFilter(null); }, [openFilter]);
    var onSearchChange = (0, react_1.useCallback)(function (event) {
        setSearch(event.target.value);
    }, []);
    var onOptionSelect = (0, react_1.useCallback)(function (value) {
        openFilter(null);
        if (activeFilter !== null && value !== activeFilter.value) {
            activeFilter.onSelect(value);
        }
    }, [activeFilter, openFilter]);
    return (react_1.default.createElement("div", { className: Selection_less_1.default['selection'] },
        react_1.default.createElement("div", { className: Selection_less_1.default['header'] },
            activeFilter === null ?
                react_1.default.createElement(react_2.default, { className: Selection_less_1.default['heading-icon'], name: 'filters' })
                :
                    null,
            react_1.default.createElement("div", { ref: headingRef, className: Selection_less_1.default['heading'], tabIndex: -1 }, activeFilter !== null ?
                react_1.default.createElement("button", { type: 'button', className: Selection_less_1.default['back-button'], "aria-label": "".concat(t('BACK'), ": ").concat(activeFilter.label), onClick: onBackClick },
                    react_1.default.createElement("span", { className: Selection_less_1.default['back-icon'] },
                        react_1.default.createElement(react_2.default, { name: 'chevron-back' })),
                    react_1.default.createElement("span", { className: Selection_less_1.default['back-label'] }, activeFilter.label))
                :
                    t('FILTERS'))),
        activeFilter !== null && activeFilter.options.length > SEARCHABLE_OPTIONS_COUNT ?
            react_1.default.createElement("div", { className: Selection_less_1.default['search'] },
                react_1.default.createElement(react_2.default, { name: 'search' }),
                react_1.default.createElement(TextInput_1.default, { type: 'search', value: search, placeholder: t('SEARCH'), "aria-label": "".concat(t('SEARCH'), ": ").concat(activeFilter.label), onChange: onSearchChange }))
            :
                null,
        react_1.default.createElement("div", { key: (_c = activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.id) !== null && _c !== void 0 ? _c : 'overview', className: Selection_less_1.default['body'] }, activeFilter !== null ?
            react_1.default.createElement(Choices_1.default, { filter: activeFilter, query: search, onSelect: onOptionSelect })
            :
                react_1.default.createElement(Overview_1.default, { inputs: inputs, onFilterClick: openFilter })),
        react_1.default.createElement("div", { className: Selection_less_1.default['footer'] },
            react_1.default.createElement("button", { type: 'button', className: Selection_less_1.default['done'], onClick: onCloseRequest }, t('DONE')))));
};
exports.default = Selection;
